import { useEffect, useRef, useState } from 'react';
import studio from '../../pages/K6ProgramPage/K6ProgramPage.module.css';

const nav = [['Home', '/'], ['K6-Program', '/k6program'], ['About', '/about'], ['Lessons', '/lessons'], ['Workbooks', '/workbooks'], ['Blog', '/blog'], ['Schedule', '/schedule']];

export function StartFree({ children, placement = 'header', className }) {
  const handleClick = (event) => {
    const funnel = window.PrepboxSignupFunnel;
    if (!funnel) return;
    funnel.click(placement);
    event.currentTarget.href = funnel.link('/trial');
  };
  return <a href="/trial" className={className} onClick={handleClick}>{children}</a>;
}


export default function StudioFrame({ children, activePath, contentId = 'studio-content' }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuButton = useRef(null);
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Instrument+Sans:ital,wdth,wght@0,75..100,400..700;1,75..100,400..700&display=swap';
    document.head.appendChild(link);
    return () => link.remove();
  }, []);
  const closeOnEscape = (event) => {
    if (event.key === 'Escape') {
      setMenuOpen(false);
      menuButton.current?.focus();
    }
  };
  const navLinks = nav.map(([label, href]) => (
    <a key={href} href={href} aria-current={href === activePath ? 'page' : undefined} onClick={() => setMenuOpen(false)}>{label}</a>
  ));
  return (
    <div className={studio.page}>
      <a className={studio.skip} href={`#${contentId}`}>Skip to content</a>
      <header className={studio.header}>
        <div className={`${studio.wrap} ${studio.headerInner}`}>
          <a className={studio.brand} href="/" aria-label="PrepBox Math Studio home">
            <img src="/home/img/logo-blue.svg" alt="PrepBox" /><span>Math Studio</span>
          </a>
          <nav className={studio.desktopNav} aria-label="Main navigation">{navLinks}</nav>
          <div className={studio.headerActions}>
            <a className={studio.callLink} href="/consultation">Speak with Min</a>
            <StartFree className={studio.button}>Start free</StartFree>
            <button ref={menuButton} className={studio.menuButton} aria-expanded={menuOpen} aria-controls="studio-navigation" onClick={() => setMenuOpen(!menuOpen)} onKeyDown={closeOnEscape}>Menu {menuOpen ? '−' : '+'}</button>
          </div>
        </div>
        <nav className={studio.mobileNav} id="studio-navigation" hidden={!menuOpen} aria-label="Mobile navigation" onKeyDown={closeOnEscape}>
          {navLinks}<a href="/consultation">Speak with Min</a>
        </nav>
      </header>
      <main id={contentId}>{children}</main>
      <footer className={studio.footer}><div className={`${studio.wrap} ${studio.footerInner}`}><div><a href="/" aria-label="PrepBox home"><img src="/home/img/logo-blue.svg" alt="PrepBox" /></a><p>Together, Math can be Fun.</p><small>© {new Date().getFullYear()} PrepBox</small></div><nav aria-label="Footer navigation"><a href="/workbooks">Workbooks</a><a href="/lessons">Lessons</a><a href="/privacy-policy">Privacy</a><a href="/terms-of-use">Terms</a></nav></div></footer>
    </div>
  );
}
